/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TravelCards from '../../account/TravelCards';
import { SendParcelWidget, TrackingSearchWidget } from '../../components/widgets';
import AccountLayout from '../../account/AccountLayout';
import * as analytics from '../../utils/analytics';

const TravelCardsPage = ({ location, pageContext }) => {
  analytics.usePageCategory('matkustajat');
  const { t: translate } = useTranslation();
  const title = translate('account.myCards.title');

  return (
    <AccountLayout
      title={title}
      paths={pageContext.paths}
      locale={pageContext.locale || 'en'}
      sidebar={
        <Box>
          <SendParcelWidget sidebar sx={{ mb: 3 }} />
          <TrackingSearchWidget sidebar />
        </Box>
      }
    >
      <TravelCards />
    </AccountLayout>
  );
};

export default TravelCardsPage;
